import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TipProgramActive, TipProgramActiveUpdate } from './tip-program-active.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TipProgramActiveService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private getTipuriProgramActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProgramActive.getTipuriProgramActive;
    private storeTipProgramActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProgramActive.storeTipProgramActive;
    private updateTipProgramActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProgramActive.updateTipProgramActive;
    private deleteTipProgramActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProgramActive.deleteTipProgramActive;
    private findByModuleUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProgramActive.findByModule;

    constructor(private http: HttpClient) { }

    addTipProgramActive(tipProgramActive: TipProgramActive) {
        return this.http.post(this.storeTipProgramActiveUrl, tipProgramActive, this.httpOptions);
    }

    updateTipProgramActive(tipProgramActive: TipProgramActiveUpdate) {
        return this.http.put(this.updateTipProgramActiveUrl, tipProgramActive, this.httpOptions);
    }

    deleteTipProgramActive(id: number) {
        return this.http.delete(this.deleteTipProgramActiveUrl + id);
    }

    getTipuriProgramActive() {
        return this.http.get(this.getTipuriProgramActiveUrl, this.httpOptions);
    }

    findByModule(id: number) {
        return this.http.get(this.findByModuleUrl + id).pipe(
            map((response: any) => response.data),
            catchError((error) => {
                console.error('Error in find tipuri program active by module:', error);
                return throwError(error);
            })
        );
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
